module.exports = ( User ) ->
  return {
    restrict: 'A'
    template: require('./result.html')

    controller: ( $scope ) ->
      $scope.userHasTaggingConfigs = ->
        User.hasTaggingConfigs()
  }
